import SelectedCustomer from '@/platform/common/components/SelectedCustomer/SelectedCustomer';
import { Header, TabNav, TabNavItem } from '@/platform/ui';
import { Link, usePage } from '@inertiajs/react';

const Navigation = () => {
    const { auth } = usePage().props;
    const { component } = usePage();

    return (
        <>
            <SelectedCustomer />

            <Header as='h2'>LKV</Header>

            <TabNav label='Pagina'>
                {auth?.permissions?.includes('view lkv') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/lkv/employees`}
                        active={'LKV/CustomerIndexView' === component}
                    >
                        Werknemers
                    </TabNavItem>
                )}
                {auth?.permissions?.includes('view lkv') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/lkv/pending-deletions`}
                        active={'LKV/CustomerPendingDeletionView' === component}
                    >
                        Te verwijderen
                    </TabNavItem>
                )}
                {auth?.permissions?.includes('edit lkv settings') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/lkv/settings/customers`}
                        active={'LKV/CustomerSettingView' === component}
                    >
                        Klant instellingen
                    </TabNavItem>
                )}
                {auth?.permissions?.includes('update questionnaires') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/lkv/settings/questionnaires`}
                        active={'LKV/QuestionnaireSettingsView' === component}
                    >
                        Vragenlijst instellingen
                    </TabNavItem>
                )}
            </TabNav>
        </>
    );
};

export default Navigation;
